import { render, staticRenderFns } from "./veSbzcZcAllocateShow.vue?vue&type=template&id=35fdb0d2&scoped=true"
import script from "./veSbzcZcAllocateShow.vue?vue&type=script&lang=js"
export * from "./veSbzcZcAllocateShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fdb0d2",
  null
  
)

export default component.exports